import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useTranslation } from 'react-i18next';
const TileCacheProgress = ({ status, progress }) => {
    const { i18n } = useTranslation();
    if (status === 'idle' || status === 'cached') {
        return null;
    }
    const getMessage = () => {
        if (status === 'downloading') {
            if (i18n.language === 'de') {
                return `Offline-Karte wird heruntergeladen... ${progress}%`;
            }
            else if (i18n.language === 'cs') {
                return `Stahování offline mapy... ${progress}%`;
            }
            return `Downloading offline map... ${progress}%`;
        }
        if (status === 'failed') {
            if (i18n.language === 'de') {
                return 'Download der Offline-Karte fehlgeschlagen';
            }
            else if (i18n.language === 'cs') {
                return 'Stahování offline mapy selhalo';
            }
            return 'Offline map download failed';
        }
        return '';
    };
    const getStatusClass = () => {
        switch (status) {
            case 'downloading':
                return 'tile-cache-progress--downloading';
            case 'failed':
                return 'tile-cache-progress--failed';
            default:
                return '';
        }
    };
    return (_jsx("div", { className: `tile-cache-progress ${getStatusClass()}`, children: _jsxs("div", { className: "tile-cache-progress__content", children: [_jsx("span", { className: "tile-cache-progress__text", children: getMessage() }), status === 'downloading' && (_jsx("div", { className: "tile-cache-progress__bar", children: _jsx("div", { className: "tile-cache-progress__bar-fill", style: { width: `${progress}%` } }) }))] }) }));
};
export default TileCacheProgress;
